import { z } from 'zod';
import { UuidString } from '../../primitives.js';
import { SubjectType } from './task.js';

/**
 * TaskRef — secondary привязка задачи к ERP-сущности (1:N, в дополнение к
 * primary subject_type+subject_id). Например задача расследования anomaly
 * затрагивает Work Order и Counterparty — primary subject=anomaly, refs=[work_order, counterparty].
 *
 * См. `docs/STAITER_UX.md` §11.8 (R8 уточнение модели) и `be-backlog.md` BE-S12.1-4.
 */

export const TaskRefRole = z.enum([
  /** Упоминается в context'е (без действия). */
  'mentions',
  /** Затрагивает работу/состояние entity. */
  'affects',
  /** Используется как доказательство/обоснование. */
  'evidence',
]);
export type TaskRefRole = z.infer<typeof TaskRefRole>;

export const TaskRef = z.object({
  id: UuidString,
  task_id: UuidString,
  ref_type: SubjectType,
  ref_id: UuidString,
  role: TaskRefRole,
});
export type TaskRef = z.infer<typeof TaskRef>;
